export default __webpack_public_path__ + "static/media/Gilroy-SemiBold.017ff10c.otf";